import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { RootStore } from 'redux/store';
import { selectTeam } from 'redux/thunks';

const Team: React.FC = () => {
	const selectedTeam = useSelector((state: RootStore) => state.user.selectedTeam);
	const dispatch = useDispatch();
	let view = <></>;

	dispatch(selectTeam(''));

	if (selectedTeam) {
		view = <Redirect push to={`/team/${selectedTeam?.teamId}/all`} />;
	} else {
		view = <Redirect push to='/' />;
	}

	return view;
};

export default Team;